import { z } from 'zod';
import { isMongoId, withPaginationParams } from '../../helpers';
import {
  EisPermission,
  LpPermission,
  CommonPermission,
} from 'further-types/admin-user-role';

export const ListRolesInput = withPaginationParams(
  z.object({
    searchQuery: z.string().optional(),
  }),
  ['name', 'createdAt', 'updatedAt'],
);

const roleNameCheck = z
  .string()
  .min(1, 'Role name is required')
  .regex(
    /^[A-Za-z0-9 ]+$/,
    'Role name can only contain letters, numbers, and spaces',
  );

const MutateEisRoleBaseInput = z.object({
  description: z.string().optional(),
  permissions: z.array(
    z.union([z.nativeEnum(EisPermission), z.nativeEnum(CommonPermission)]),
  ),
});
export const CreateEisRoleInput = MutateEisRoleBaseInput.extend({
  name: roleNameCheck,
  firmId: z.string().refine(isMongoId()).optional(),
});
export const UpdateEisRoleInput = MutateEisRoleBaseInput.extend({
  roleId: z.string().refine(isMongoId()),
});

const MutateLpRoleBaseInput = z.object({
  description: z.string().optional(),
  permissions: z.array(
    z.union([z.nativeEnum(LpPermission), z.nativeEnum(CommonPermission)]),
  ),
});
export const CreateLpRoleInput = MutateLpRoleBaseInput.extend({
  name: roleNameCheck,
  lpFirmId: z.string().refine(isMongoId()).optional(),
});
export const UpdateLpRoleInput = MutateLpRoleBaseInput.extend({
  roleId: z.string().refine(isMongoId()),
});
